
/**
 * @fileOverview ContentToggleController Module File.
 *

 *
 * @author jmaki
 * @version 1.0
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/ContentToggleController',['require','lib/Util','jquery','views/BackdropView','GlobalEventDispatcher'],function (require) {
        var Util = require('lib/Util');
        var $ = require('jquery');
        var BackdropView = require('views/BackdropView');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');

        /**
         * This file is used to handle the showing/hiding of content. It is configurable to support the two main contexts in
         * which it is used.  The showing and hiding of the fly-out nav in mobile, and the showing and hiding of the content
         * drawers.
         *
         * @class ContentToggleController
         * @param element {Element} the domElement to bind to the event
         * @constructor
         */

        $debug('ContentToggleController loaded - use ?debug=contentToggleControl for messages', 'contentToggleControl');
        var ContentToggleController = function (element) {
            this.$trigger = $(element); // wraps the trigger element in a jQuery object

            $debug('     Trigger Element: ' + $.trim(this.$trigger.text()),'contentToggleControl');


            this.settings = undefined; // used to store the settings
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application
            this.hasTarget = false;  // if ContentToggleController needs to update another DOM element in sync, this is true
            this.backdropView = undefined; // if ContentToggleController needs to activate/deactivate a backdrop
            this.isLocked = false;   // used to lock the controller, until the completion of an open or close event
            this.isEnabled = false;  // used to track if the object is enabled
            this.isOpen = false;     // used to track if the object is currently in its 'open' state
            this.init();
        };

        /**
         * Initializes the Controller
         *
         * @method init
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.init = function () {
            this.isEnabled = false;

            if (this.$trigger.length > 0) {
                return this.setOptions()
                    .createChildren()
                    .setupHandlers()
                    .enable()
                    .jumpToLocations();
            }
        };

        /**
         *
         * This takes in data options from the markup and overwrites base values. If there is no value in the data
         * options tag then defaults are shown below.
         *
         * @method setOptions
         * @returns {ContentToggleController}
         */

        ContentToggleController.prototype.setOptions = function () {
            var options = this.$trigger.data().options;
            /* ToDo - Task: make some of the default class names more generic (isActive etc) */
            var defaults = {
                target: undefined,
                targetActiveClass: undefined,
                triggerActiveClass: 'MMM--navItemList-hasSubNav_isOpen',
                closeOn: ['contentOpen', 'contextChange', 'contentClose'],
                openEvent: 'contentOpen',
                closeEvent: undefined,
                enabledMobile: false,
                hasBackdrop: false,
                backdropActiveClass: undefined,
                disableOn: [],
                enableOn: ['largeContext', 'luxuryContext', 'smallContext', 'mediumContext'],
                bodyShiftOnOpen: false,
                scrollToOnOpen: undefined
            };
            this.settings = $.extend({}, defaults, options);
            //output debug items
            $debug('     SubMenuConroller Options ', 'contentToggleControl');
            $debug('          HTML data-options Settings: ','contentToggleControl');
            $debug('          Default Settings: ' + $printObj(defaults),'contentToggleControl');
            $debug('          Combined Settings: ' + $printObj(this.settings),'contentToggleControl');
            $debug('','contentToggleControl');
            $debug('','contentToggleControl');
            //end debug block
            return this;
        };

        /**
         *
         * This tests the URL to determine if should open specific drawer or not. Used for Change Location GSN behavior
         *
         * @method jumpToLocations
         * @returns {ContentToggleController}
         */

        ContentToggleController.prototype.jumpToLocations = function () {
            var self = this;
            $debug('Testing to see if URL has changeLocation Parameter... ','contentToggleControl');
            self.settings.localizationDrawerOpen = false;
            if (window.location.hash === '#changeLocation' || urlHash['changeLocation']) {
                if (self.settings.localizationDrawerOpen === false) {
                    $('.MMM--localizationTrigger').click();
                    self.settings.localizationDrawerOpen = true;
                }
            }
            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.createChildren = function () {
            // if the trigger has data-target, use that as the target, otherwise leave it undefined
            if (this.settings.target) {
                this.$target = $('#' + this.settings.target);
            }


            if (this.$target !== undefined) {
                this.hasTarget = true;
            }

            if (this.settings.hasBackdrop === true) {

                var options = {
                    backdropActiveClass: this.settings.backdropActiveClass,
                    bodyShift: this.settings.bodyShiftOnOpen
                };

                this.backdropView = new BackdropView(this.closeCallback.bind(this), options);
            }

            if (this.settings.bodyShiftOnOpen) {
                this.$bodyWrapper = $('#js-bodyWrapper'); //cache the body reference if you are going to need to use it
                this.$menuWrapper = $('#js-mobileMenuWrapper');
            }

            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @method setupHandlers
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.setupHandlers = function () {
            var self = this,
                i,
                obj;

            // subscribe to the events that should cause the close function to run
            for ( i = 0; i < this.settings.closeOn.length; i++) {
                obj = this.settings.closeOn[i];
                if (obj === 'contextChange') {
                    self.eventDispatcher.subscribe(obj, this.closeContent.bind(self, 0));
                } else if (obj === 'contentOpen') {
                    self.eventDispatcher.subscribe(obj, this.closeContent.bind(self, 0));
                } else {
                    self.eventDispatcher.subscribe(obj, this.closeContent.bind(self));
                }
            }

            //ToDo Create 'contextualizer' class that handles this, add the class to NavigationSubMenu as well
            // subscribe to the events that should cause the the function to enable
            for (i = 0; i < this.settings.enableOn.length; i++) {
                obj = this.settings.enableOn[i];
                self.eventDispatcher.subscribe(obj, this.enable.bind(self));
            }
            // subscribe to the events that should cause the the function to disable
            for (i = 0; i < this.settings.disableOn.length; i++) {
                obj = this.settings.disableOn[i];
                self.eventDispatcher.subscribe(obj, this.disable.bind(self));
            }

            // the event is bound to the anchor in the tab, bound to touchend to prevent swiping from triggering tabs

            this.$trigger.on('click', '.js-triggerLink', function (event) {
                $debug($.trim(self.$trigger.text()) + ' Element Clicked!','contentToggleControl');
                if (self.$target){
                    $debug('Toggling ' + self.$target.attr('id'),'contentToggleControl');
                }

                //needed for IE Support
                if (event.preventDefault) {
                    event.preventDefault();
                } else {
                    event.returnValue = false;
                }
                if (self.isEnabled === false) {
                    return;
                }
                self.contentToggle();
            });

            // close the drawer which is manually added via ajax as well as normal way
            $('.js-subNavDrawer').on('click', '.js-closeLink', function (event) {

                //needed for IE Support
                if (event.preventDefault) {
                    event.preventDefault();
                } else {
                    event.returnValue = false;
                }

                self.eventDispatcher.publish(GlobalEventDispatcher.EVENTS.CONTENT_CLOSE);
            });

            return this;
        };

        /**
         * Sets the isEnabled flag to true
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.enable = function () {
            if (this.isEnabled) {
                return this;
            } else {
                this.isEnabled = true;
            }
            return this;
        };

        /**
         * Sets the isEnabled flag to false
         * Exits early if it is already disabled
         *
         * @method disable
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            } else {
                this.isEnabled = false;
            }
            return this;
        };

        /**
         * Disables the module, can be extended to remove handlers if needed
         *
         * @method destroy
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.destroy = function () {
            this.disable();
            return this;
        };

        /**
         * This callback is passed to the backdrop.
         *
         * @method closeCallBack
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.closeCallback = function () {
            if (this.isLocked) {
                return this;
            }
            this.closeContent(500);
        };

        /**
         * This callback is passed to the backdrop.
         *
         * @method openCallBack
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.openCallback = function () {
            var self = this;
            $debug('open callback!', 'contentToggleControl');

            if (window.location.hash === '#changeLocation' || urlHash['changeLocation']) {
                if (self.$target.attr('id') === 'localizationDrawer'){
                    self.scrollToContainer();
                }
            }
        };


        /**
         * This callback is passed to the backdrop.
         *
         * @method closeCallBack
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.scrollToContainer = function () {
            var self = this;
            var targetElement = self.$target;
            $debug('in scroll container for ' + targetElement.attr('id'), 'contentToggleControl');
            $('html, body').animate({ scrollTop: self.$target.offset().top }, 1000);
        };


        /* ToDo - Task: look into ways to eliminate repeated code closeDrawer/openDrawer */
        /**
         * Function that closes the drawer in question
         *
         * @method closeContent
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.closeContent = function (speed) {

            var self = this;
            var transition = 500;

            //if this is disabled or not open, return
            if (this.isEnabled === false || this.isOpen === false) {
                return;
            }

            if (this.settings.closeEvent !== undefined) {
                this.eventDispatcher.publish(this.settings.closeEvent);
            }

            // speed is an optional parameter to force an close without transition, passed on the openEvent
            if (speed > -1) {
                transition = speed;
            }

            /* ToDo - Task: decouple the active states for future release */
            if (this.hasTarget) {
                self.$target.slideUp(transition, function() {
                    self.$target.removeClass(self.settings.targetActiveClass);
                    self.$trigger.removeClass(self.settings.triggerActiveClass);
                    self.$target.attr('style', '');
                });
            } else {
                self.$trigger.removeClass(self.settings.triggerActiveClass);
            }

            if (this.backdropView) {
                this.backdropView.hide();
            }

            if (this.settings.bodyShiftOnOpen === true) {
                this.$bodyWrapper.removeClass('MMM--menuIsOpen');
                this.$bodyWrapper.addClass('MMM--menuIsClosed');
                self.$trigger.removeClass(self.settings.triggerActiveClass);
            }

            this.isOpen = false;

        };

        /**
         * Opens the target in question
         *
         * @method openContent
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.openContent = function() {

            var self = this;
            var $element = self.$trigger;
            self.eventDispatcher.publish(self.settings.openEvent);
            $element.addClass(self.settings.triggerActiveClass);

            //trigger the open event at the end of the transition, or else immediately
            if (this.hasTarget) {
                this.$target.slideDown(500, function() {
                    self.$target.addClass(self.settings.targetActiveClass);
                    $debug('option 1', 'contentToggleControl');
                    self.openCallback();
                });
            } else {
                this.eventDispatcher.publish(this.settings.openEvent);
                $debug('option 2', 'contentToggleControl');
            }

            if (this.backdropView) {
                this.backdropView.show();
            }

            if (this.settings.bodyShiftOnOpen) {
                this.$bodyWrapper.removeClass('MMM--menuIsClosed');
                this.$bodyWrapper.addClass('MMM--menuIsOpen');
            }

            if (this.settings.scrollToOnOpen) {
                $('html, body').scrollTop(self.settings.scrollToOnOpen);
            }

            this.isOpen = true;

        };
        /**
         * Toggles the content, locks the transition, uses DOM to check current state
         * then calls close or open where appropriate
         *
         * @method contentToggle
         * @returns {ContentToggleController}
         */
        ContentToggleController.prototype.contentToggle = function () {
            var self = this;
            self.isLocked = true;

            window.setTimeout(function(){
                self.isLocked = false;
            }, 500);

            if (self.$trigger.hasClass(self.settings.triggerActiveClass)) {
                self.closeContent();
            } else {
                self.openContent();
            }
            return this;
        };

        return ContentToggleController;
    });

}(MMMRequire));

